import { useEnvironmentInterface } from "environment-interface";
import { usePitcher } from "features/utils/usePitcher";

import type { Command } from "../../types";

export const useCreateNewTaskCommand = (): Command => {
  const { monacoEditor } = useEnvironmentInterface();
  const pitcher = usePitcher();

  return {
    id: "codesandbox.tasks.createTask",
    name: "Create New Task",
    section: "CodeSandbox Tasks",
    binding: "Control+Shift+`",
    perform: async () => {
      const api = await monacoEditor.getExtensionApi();

      const taskName = await api.window.showInputBox({
        title: "Create New Task",
        prompt: "Enter a name for the task",
        placeHolder: "Install Dependencies",
        ignoreFocusOut: true,
      });
      if (!taskName) {
        return;
      }

      const taskCommand = await api.window.showInputBox({
        title: "Create New Task",
        prompt: "Enter the command of the task",
        ignoreFocusOut: true,
        placeHolder: "npm install",
      });

      if (!taskCommand) {
        return;
      }

      pitcher.clients.task.runCommand(taskCommand, true, taskName);
    },
  };
};
